import {
  css
} from 'lit';
export const ButtonGroupToggleStyle = css`

  .lds-button-group-toggle-btn {
    box-shadow: none;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    border-top-right-radius: var(--lds-radius-button-group);
    border-bottom-right-radius: var(--lds-radius-button-group);
    padding-left: var(--lds-spacing-button-group-toggle-padding-left);
    padding-right: var(--lds-spacing-button-group-toggle-padding-right);
    padding-top: calc(var(--lds-spacing-button-padding-top) - var(--lds-border-button-width));
    padding-bottom: calc(var(--lds-spacing-button-padding-bottom) - var(--lds-border-button-width));
    border-right-width: var(--lds-border-width-right-button-group);
  }

  .lds-button-group-toggle-btn .button-icon {
    --lds-spacing-icon-margin-top: var(--lds-spacing-button-subcomponent-icon-margin-top);
  }

  .lds-button-group-toggle-btn:focus {
    outline-color: var(--lds-color-button-focus-outline);
    outline-offset: var(--lds-border-button-focus-outline-offset);
    outline-style: var(--lds-border-button-focus-outline-style);
    outline-width: var(--lds-border-button-focus-outline-width);
    box-shadow: var(--lds-shadow-button-focus) var(--lds-color-button-focus-shadow);
  }

  .lds-button-group-toggle-btn[disabled] {
    cursor: var(--lds-animation-button-cursor-disabled);
  }

  .split-icon {
    display: block;
    transition: .35s transform ease;
  }

  .split-icon.open {
    transform: translateY(-.125rem) rotate(180deg);
  }

`;
export default ButtonGroupToggleStyle;
